import React from 'react'
import { ALL_SET, NEEDS_TWEAKS, NOT_READY } from '@chegg-wt/core-wa/constants/paraphraser'
import { useSelector } from 'react-redux'
import {
  feedbacksSelector,
  paperRequiresRecheckSelector,
} from '@chegg-wt/core-wa/state/selectors'
import {
  ProgressBarContainer,
  ProgressBarHeading,
  ProgressLineStatus,
  ProgressLineStatusArea,
} from './styled'
import ProgressLine from './ProgressLine'
import { ProgressBarProps } from './types'

const ProgressBar = ({
  heading,
  progressBarColor,
  defaultColor,
  progressBarPercentage,
}: ProgressBarProps) => {
  const feedbacksList = useSelector(feedbacksSelector)
  const requiresReCheck = useSelector(paperRequiresRecheckSelector)

  // hide progress bar if all feedbacks accepted/discarded and requires re-check cos of manual edit
  if ((!feedbacksList || feedbacksList.length === 0) && requiresReCheck) {
    return null
  }
  return (
    <ProgressBarContainer>
      <ProgressBarHeading>{heading}</ProgressBarHeading>
      <div>
        <ProgressLineStatusArea>
          <ProgressLineStatus>{NOT_READY}</ProgressLineStatus>
          <ProgressLineStatus>{NEEDS_TWEAKS}</ProgressLineStatus>
          <ProgressLineStatus>{ALL_SET}</ProgressLineStatus>
        </ProgressLineStatusArea>

        <ProgressLine
          progressBarPercentage={progressBarPercentage}
          progressBarColor={progressBarColor}
          defaultColor={defaultColor}
        />
      </div>
    </ProgressBarContainer>
  )
}
export default ProgressBar
